/* eslint-disable max-len */
import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import { Badge } from '../../../../../atoms/Badge'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
} from '../../../BuildingCharacteristics.styles'
import type { CohesionBreakdownCardProps } from '../NeighborhoodContextTab.types'

export const CohesionBreakdownCard: React.FC<CohesionBreakdownCardProps> = ({
  neighborhoodAnalysis,
  t,
}) => {
  const score = neighborhoodAnalysis.quartier_analysis.quartier_score

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="pie-chart" size="small" />
          {t('neighborhood.cards.cohesionBreakdown.title')}
          <InfoTooltip>
            <TooltipMetricExplanation
              title={t('neighborhood.cards.cohesionBreakdown.tooltip.title')}
              shortDescription={t(
                'neighborhood.cards.cohesionBreakdown.tooltip.description'
              )}
              calculation={t(
                'neighborhood.cards.cohesionBreakdown.tooltip.calculation'
              )}
              importance={t(
                'neighborhood.cards.cohesionBreakdown.tooltip.importance'
              )}
            />
          </InfoTooltip>
        </CardTitle>
        <Badge
          variant={score >= 70 ? 'success' : score >= 40 ? 'warning' : 'danger'}
        >
          {score.toFixed(1)}
        </Badge>
      </CardHeader>
      <MetricGrid>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.cohesion.temporal.label')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('neighborhood.cohesion.temporal.tooltip.title')}
                shortDescription={t(
                  'neighborhood.cohesion.temporal.tooltip.description'
                )}
                calculation={t(
                  'neighborhood.cohesion.temporal.tooltip.calculation'
                )}
                source={t('neighborhood.cohesion.temporal.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {neighborhoodAnalysis.quartier_analysis.cohesion_breakdown.temporal.score.toFixed(
              1
            )}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.cohesion.physical.label')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('neighborhood.cohesion.physical.tooltip.title')}
                shortDescription={t(
                  'neighborhood.cohesion.physical.tooltip.description'
                )}
                calculation={t(
                  'neighborhood.cohesion.physical.tooltip.calculation'
                )}
                source={t('neighborhood.cohesion.physical.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {neighborhoodAnalysis.quartier_analysis.cohesion_breakdown.physical.score.toFixed(
              1
            )}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.cohesion.typological.label')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('neighborhood.cohesion.typological.tooltip.title')}
                shortDescription={t(
                  'neighborhood.cohesion.typological.tooltip.description'
                )}
                calculation={t(
                  'neighborhood.cohesion.typological.tooltip.calculation'
                )}
                source={t('neighborhood.cohesion.typological.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {neighborhoodAnalysis.quartier_analysis.cohesion_breakdown.typological.score.toFixed(
              1
            )}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.cohesion.density.label')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('neighborhood.cohesion.density.tooltip.title')}
                shortDescription={t(
                  'neighborhood.cohesion.density.tooltip.description'
                )}
                calculation={t(
                  'neighborhood.cohesion.density.tooltip.calculation'
                )}
                source={t('neighborhood.cohesion.density.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {neighborhoodAnalysis.quartier_analysis.cohesion_breakdown.density.score.toFixed(
              1
            )}
          </MetricValue>
        </MetricRow>
      </MetricGrid>
    </Card>
  )
}
